@if(Absetzung != null)
{
  <div class="FileList">
    @for (file of Files; track file.key) {
      <div class="row file">
        <a class="col" href="/Backend/File/{{file.key}}">{{file.name}}</a>
        <div class="col-auto"> <i class="bi bi-trash3 DeleteButton" style="color:red;" (click)="DeleteFile(file.key)"></i></div>
      </div>
    }
  </div>
  <div class="row Upload">
    <div class="col">
      <div class="btn btn-primary" (click)="UploadFile()">Hochladen</div>
    </div>
  </div>

}
